import React from 'react';
import type { Event } from '@/types/event';
import MainContent from './MainContent';
import ActionSection from './ActionSection';

interface ModalContentProps {
  event: Event;
  onReserve: () => void;
  onClose: () => void;
  isRegistered: boolean;
  quota?: any;
}

const ModalContent: React.FC<ModalContentProps> = ({ event, onReserve, onClose, isRegistered = false, quota: myQuotas = {} }) => (
  <div className="relative z-10 px-4 sm:px-6 lg:px-8 pt-2 h-full flex flex-col">
    <MainContent event={event} quota={myQuotas} />
    {<ActionSection event={event} isRegistered={isRegistered} onReserve={onReserve} onClose={onClose} />}
  </div>
);

export default ModalContent;